import jStat from 'jstat';

export interface StandardDeviationResult {
  population: {
    standardDeviation: number;
    variance: number;
  };
  sample: {
    standardDeviation: number;
    variance: number;
  };
  mean: number;
  data: number[];
  interpretation: string;
}

export function calculateStandardDeviation(data: number[]): StandardDeviationResult {
  const sortedData = [...data].sort((a, b) => a - b);
  const mean = jStat.mean(data);
  const popStdDev = jStat.stdev(data, true);  // population
  const sampleStdDev = jStat.stdev(data, false);  // sample
  const popVariance = jStat.variance(data, true);
  const sampleVariance = jStat.variance(data, false);
  
  return {
    population: {
      standardDeviation: popStdDev,
      variance: popVariance
    },
    sample: {
      standardDeviation: sampleStdDev,
      variance: sampleVariance
    },
    mean,
    data: sortedData,
    interpretation: `The population standard deviation is ${popStdDev.toFixed(2)} (variance: ${popVariance.toFixed(2)}), and the sample standard deviation is ${sampleStdDev.toFixed(2)} (variance: ${sampleVariance.toFixed(2)}). About 68% of the data falls within ±1 standard deviation of the mean (${mean.toFixed(2)}).`
  };
} 